export default __webpack_public_path__ + "static/media/our-products.2c5f305f.jpg";